import * as React from 'react';

import backgroundPrimary from '../../assets/images/backgroundPrimary.png'
import { makeStyles, Theme } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';

import { Button, Card } from '@material-ui/core';
import loginLogo from '../../assets/images/loginLogo.png'
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../shared/theme';

import api from '../../store/api';
import { useState } from 'react';

import { useForm, Controller } from "react-hook-form";
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { getPasswordStrength, PasswordStrength } from '../../common/utility'
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundImage: `url(${backgroundPrimary})`,
        backgroundBlendMode: 'overlay',
        backgroundColor: 'rgba(0, 21, 46, 0.6)',
        boxShadow: 'none',
        width: '100%',
        height: '100%',
        position: 'fixed',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingTop: 80,
        paddingLeft: 40
    },
    container: {
        width: 461,
        background: theme.palette.primary.main,
        borderRadius: 0,
    },

    inputs: {
        marginTop: 10,
        marginLeft: 40,
        marginRight: 40,
    },
    button: {
        width: '100%',
        padding: 9,
        borderRadius: 5,
        background: 'white',
        color: theme.palette.primary.main,
        marginBottom: 40,
        fontSize: 'medium',
    },
    link: {
        color: 'whitesmoke',
        marginBottom: 30,
        marginLeft: 40,
        paddingLeft: 0,
        fontSize: 'small'
    },
    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: '30px',
        marginRight: 'auto',
        width: 374.67,
    },
    logoRoot: {
        height: 150
    },
    MailIcon: {
        marginLeft: 40,

    },
    mailOutlineIcon: {
        color: '#fff',
        fontSize: 44,
    },
    signUpHeading: {
        fontFamily: 'lato',
        fontSize: 28,
        color: '#fff',
        fontWeight: 'bold',
        lineHeight: 'normal',
        marginLeft: '40px !important',
        marginBottom: 60,
    },
    heading: {
        marginLeft: 40,
    },
    form: {
        marginBottom: 40,
    },
    textFieldRoot: {
        width: '100%',
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderRadius: '5px',
    },
    textFieldInput: {
        backgroundColor: 'rgba(255,255,255, 0.25)',
        color: '#fff',
        borderRadius: '5px',
    },

    alertErrorRoot: {
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 40,
        marginTop: 40
    },

    alertSuccessRoot: {
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 40,
        marginTop: 40
    },
    labels: {
        marginTop: 30,
        marginLeft: 40,
        marginRight: 40,
        color: 'white'
    },
}));


export interface IResetPasswordConfirmed {
    requestId: string,
    completeResetPassword: () => void
}

function ResetPasswordConfirmed(props: IResetPasswordConfirmed): JSX.Element {
    const classes = useStyles();
    const [errorMessagePassword, setErrorMessagePassword] = useState(false);
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useForm();
    let passwordWatch = watch('password');
    const history = useHistory();

    React.useEffect(() => {
        validateRequest();
    }, [props.requestId])


    const [isValidRequest, setIsValidRequest] = useState<boolean>(true);
    const validateRequest = async (): Promise<void> => {
        var res = await api.validateResetPasswordRequest(`requestId=${props.requestId}`);
        if (res == true) {
            setIsValidRequest(true)
        }
        else {
            setIsValidRequest(false);
        }
    }


    const [passwordStrength, setPasswordStrength] = useState<PasswordStrength>(PasswordStrength.none);


    const [resetPasswordStep, setResetPasswordStep] = useState(0);
    const resetPassword = async (data: any): Promise<void> => {
        let req: { [index: string]: string } = {
            'requestId': props.requestId,
            'password': data.password
        }
        await api.resetPassword('', req);
        setResetPasswordStep(1);

    }


    const updatePasswordStrengtLabel = () => {
        let fontColor = '#FF806F';
        if (passwordStrength === PasswordStrength.good) {
            fontColor = '#6DE99E';
        }
        else if (passwordStrength === PasswordStrength.moderate) {
            fontColor = '#FFEF4C';
        }
        return (
            <label style={{ color: fontColor }}> {passwordStrength} </label >
        )
    }

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {

        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);

    const handleClickShowConfirmedPassword = () => {

        setShowConfirmedPassword(!showConfirmedPassword);
    };

    const handleMouseDownConfirmedPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const passwordStrength = getPasswordStrength(e.target.value);
        setPasswordStrength(passwordStrength);
    }

    const backToLogin = () => {
        history.push('/login');
    }
    return (
        <div className={classes.root}>
            <React.Fragment>

                <Card className={classes.container}>
                    <div className={classes.logoRoot}>
                        <img src={loginLogo} className={classes.logoImg} alt="logo" />
                    </div>

                    <div>
                        <h2 className={classes.signUpHeading}>Reset your password</h2>
                    </div>
                    <div style={{ display: resetPasswordStep == 0 ? 'block' : 'none' }}>
                        <div style={{ display: !isValidRequest ? 'block' : 'none' }}>
                            <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" className={classes.alertErrorRoot} >
                                Your request password link is invalid
                            </Alert>

                        </div>
                        <div style={{ display: isValidRequest ? 'block' : 'none' }}>
                            <form onSubmit={handleSubmit(resetPassword)}>

                                <div className={classes.inputs}>
                                    <Controller
                                        control={control}
                                        render={({ onChange, onBlur, value, name }) => (<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                            classes: {
                                                root: classes.textFieldInput
                                            },
                                            endAdornment: <InputAdornment position="end">
                                                <IconButton style={{ color: '#fff' }}
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}>
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }}
                                            onBlur={onBlur}
                                            value={value}
                                            name={name}
                                            onChange={e => {
                                                let pwdStrength = getPasswordStrength(e.target.value);
                                                setPasswordStrength(pwdStrength);
                                                onChange(e)
                                            }}
                                            variant='outlined' placeholder='New Password' type={showPassword ? 'text' : 'password'} error={errors.password} helperText={errors.password ? errors.password.message : ""} />)}
                                        name='password'
                                        rules={{
                                            required: "Password is required",
                                            validate: (value) => {
                                                let pwdStrength = getPasswordStrength(value);
                                                if (pwdStrength !== PasswordStrength.good) {
                                                    setErrorMessagePassword(true);
                                                    return false;
                                                }
                                                else {
                                                    setErrorMessagePassword(false);
                                                    return true;
                                                }
                                            }
                                        }}
                                    />
                                </div>
                                <div className={classes.inputs}>
                                    <Controller
                                        control={control}
                                        as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                            classes: {
                                                root: classes.textFieldInput
                                            },
                                            endAdornment: <InputAdornment position="end">
                                                <IconButton style={{ color: '#fff' }}
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowConfirmedPassword}
                                                    onMouseDown={handleMouseDownConfirmedPassword}>
                                                    {showConfirmedPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }} variant='outlined' placeholder='New Confirmed Password' type={showConfirmedPassword ? 'text' : 'password'} error={errors.confirmedPassword} helperText={errors.confirmedPassword ? errors.confirmedPassword.message : ""} />}
                                        name='confirmedPassword'
                                        rules={{
                                            required: "Confirmed Password is required",
                                            validate: (value) => {
                                                if (passwordWatch === value) {
                                                    return true;
                                                }
                                                else {
                                                    return "Confirmed Password does not match"
                                                }
                                            }
                                        }}
                                    />
                                </div>
                                <div className={classes.labels} style={{ marginTop: 10 }}>
                                    <label>Password strength:{' '}</label>
                                    {updatePasswordStrengtLabel()}

                                </div>


                                {
                                    errorMessagePassword ?
                                        <div>
                                            <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" className={classes.alertErrorRoot} >
                                                Please enter a stronger password to continue. Try making your password longer, adding special characters (!@#$%^^&*), adding numbers and using upper case letters.
                                        </Alert>
                                        </div>
                                        : null
                                }


                                <div className={classes.inputs}>
                                    <Button type="submit"
                                        className={classes.button}
                                        variant="contained"
                                        disabled={formState.isSubmitting}>Reset Password</Button>
                                </div>

                            </form>
                        </div>

                    </div>
                    <div style={{ display: resetPasswordStep == 1 ? 'block' : 'none' }}>
                        <Alert variant="filled" severity="success" classes={{ root: classes.alertSuccessRoot }} >
                            Your password has been successfully reset.
                                </Alert>
                        <div className={classes.inputs}>
                            <Button
                                className={classes.button}
                                variant="contained" onClick={backToLogin}>Back to sign in</Button>
                        </div>
                    </div>
                </Card>

            </React.Fragment >
        </div>
    );
}

export default ResetPasswordConfirmed